import { render, staticRenderFns } from "./FigureBodyDetail.vue?vue&type=template&id=3589fc80&scoped=true"
import script from "./FigureBodyDetail.vue?vue&type=script&lang=js"
export * from "./FigureBodyDetail.vue?vue&type=script&lang=js"
import style0 from "./FigureBodyDetail.vue?vue&type=style&index=0&id=3589fc80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3589fc80",
  null
  
)

export default component.exports